<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 8 14">
    <path d="M0.25 2h5.5q0.102 0 0.176 0.074t0.074 0.184v6.742h1.5q0.312 0 0.453 0.289t-0.070 0.539l-2.5 3q-0.141 0.172-0.383 0.172t-0.383-0.172l-2.5-3q-0.203-0.242-0.070-0.539 0.141-0.289 0.453-0.289h1.5v-5h-2.5q-0.109 0-0.195-0.086l-1.25-1.5q-0.102-0.109-0.031-0.266 0.070-0.148 0.227-0.148z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-level-down.html